<script>
    import TableCell from './TableCell.svelte';

    export let row = [];
    export let headers = [];
    export let headerOptions = {};
</script>

<tr>
    {#each row as cell, cellIndex}
        <TableCell {cell} header={headers[cellIndex]} {headerOptions} />
    {/each}
</tr>
